
import { api, handleToast, reLoadPage } from "./config";

export async function AddGetWay(data) {
    api.post('gateway/payments', data, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorization': `Bearer ${localStorage.getItem('login')}`
        }
    }).then(()=>handleToast('success', 'فرم پرداخت با موفقیت ساخته شد'))
    .catch((error) => {
        if (error.request.status === 401) {
            reLoadPage()
        }
       console.log(error);
       handleToast('error', error.response.data.message)
    })

}